import { CompanyLogo, LogoUploadButton, useCompanies } from "@/components/CompanySwitcher";
import api from "@/lib/api";
import { toast } from "sonner";
import { Building2, Trash2 } from "lucide-react";

export function CompanySettings() {
  const { list, reload } = useCompanies();
  const removeLogo = async (id) => {
    if (!window.confirm("Logo kaldırılsın mı?")) return;
    try { await api.delete(`/companies/${id}/logo`); toast.success("Logo kaldırıldı"); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Logo kaldırılamadı"); }
  };
  return (
    <div className="mt-8 rounded-xl border border-border bg-card p-6 max-w-3xl" data-testid="company-settings">
      <div className="flex items-center gap-2 font-display font-bold text-lg"><Building2 className="w-5 h-5 text-amber-600" /> Şirket Ayarları</div>
      <p className="text-sm text-muted-foreground mt-1 mb-4">Logolar açılış sayfasında ve sol menüde görünür. PNG, JPG veya WEBP (en fazla 3 MB).</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {list.map(c => (
          <div key={c.id} className="flex items-center gap-4 rounded-lg border border-border p-4" data-testid={`company-setting-${c.id}`}>
            <CompanyLogo company={c} className="w-16 h-16 border border-border" testid={`settings-logo-${c.id}`} />
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-sm leading-snug">{c.name}</div>
              <div className="flex gap-3 mt-2">
                <LogoUploadButton companyId={`${c.id}`} onDone={reload} label={c.logo_url ? "Logo değiştir" : "Logo yükle"} className="text-amber-700 dark:text-amber-400 hover:underline font-semibold" />
                {c.logo_url && (
                  <button onClick={() => removeLogo(c.id)} className="inline-flex items-center gap-1 text-xs text-rose-600 hover:underline" data-testid={`logo-remove-${c.id}`}>
                    <Trash2 className="w-3.5 h-3.5" /> Kaldır
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
